import buyToken1 from '../../../assets/svgs/buy_token_1.svg';
import buyToken2 from '../../../assets/svgs/buy_token_2.svg';
import buyToken3 from '../../../assets/svgs/buy_token_3.svg';
import buyToken4 from '../../../assets/svgs/football_american.svg';
// import buyToken4 from '../../../assets/svgs/buy_token_4.svg';
import { APP_NAME_SHORT } from '../../../lib/constants/globalConstant';

const tokensData = [
    {
        id: 1,
        heading: "Experience the Game Like Never Before",
        description: `Being a fan has never been this interactive. With ${APP_NAME_SHORT}, you're not just watching the game—you're part of it.`,
        image: buyToken4,
    },
    {
        id: 2,
        heading: "Own a Piece of Your Team",
        description: "Feel the pride of ownership as you claim your section of the field, turning your passion into something tangible and lasting.",
        image: buyToken2,
    },
    {
        id: 3,
        heading: "Exclusive Rewards & Collectibles",
        description: "From points to prizes, your token gives you access to a world of exclusive content and rewards.",
        image: buyToken3,
    },
    // {
    //     id: 4,
    //     heading: "Trade and Grow Your Collection",
    //     description: "Every Game NFT is a piece of sports history that you can trade, collect, or showcase. Build your ultimate collection.",
    //     image: buyToken4,
    // },
]

export default tokensData